// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from 'react';
import {
  PlasmicProfileInfo,
  DefaultProfileInfoProps,
} from './plasmic/paziresh_24_profile/PlasmicProfileInfo';
import { HTMLElementRefOf } from '@plasmicapp/react-web';
import DoctorAvatarLightbox from '@/modules/profile/components/head/doctorAvatarLightbox';
import { useProfileDataStore } from '@/modules/profile/store/profileData';
import {
  canPreviewDoctorProfileImage,
  displayedDoctorProfileImageUrl,
  toDoctorProfileLightboxSrc,
} from '@/modules/profile/utils/doctorProfileImageUrl';

export interface ProfileInfoProps extends DefaultProfileInfoProps {}

function ProfileInfo_(props: ProfileInfoProps, ref: HTMLElementRefOf<'div'>) {
  const { imageUrl, displayName } = props;
  const [lightboxOpen, setLightboxOpen] = React.useState(false);
  const [imageFailed, setImageFailed] = React.useState(false);
  const gender = useProfileDataStore(state => (state.data as { gender?: unknown } | undefined)?.gender);

  React.useEffect(() => {
    setImageFailed(false);
  }, [imageUrl]);

  const displayImageUrl = displayedDoctorProfileImageUrl(imageUrl, gender, imageFailed);
  const lightboxSrc = displayImageUrl ? toDoctorProfileLightboxSrc(displayImageUrl) : '';
  const canPreview = canPreviewDoctorProfileImage(lightboxSrc);

  const openLightbox = React.useCallback(() => {
    if (!canPreview) return;
    setLightboxOpen(true);
  }, [canPreview]);

  const closeLightbox = React.useCallback(() => {
    setLightboxOpen(false);
  }, []);

  const previewLabel = displayName?.trim()
    ? `بزرگ‌نمایی عکس ${displayName}`
    : 'بزرگ‌نمایی عکس پزشک';

  return (
    <>
      <PlasmicProfileInfo
        root={{ ref }}
        {...props}
        imageUrl={displayImageUrl}
        avatar={{
          wrap: node =>
            canPreview ? (
              <button
                type="button"
                className="relative inline-flex shrink-0 cursor-pointer rounded-full border-0 bg-transparent p-0 touch-manipulation focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
                onClick={openLightbox}
                aria-label={previewLabel}
              >
                {node}
              </button>
            ) : (
              node
            ),
          props: {
            onImageError: () => setImageFailed(true),
          },
        }}
      />
      {canPreview && (
        <DoctorAvatarLightbox
          src={lightboxSrc}
          visible={lightboxOpen}
          onClose={closeLightbox}
          displayName={displayName}
        />
      )}
    </>
  );
}

const ProfileInfo = React.forwardRef(ProfileInfo_);
export default ProfileInfo;
